<template>
  <div class="error">
    <Header/>
    <Banner
      image="hero-image@2x.jpg"
      alt=""
    />
    <!-- eslint-disable -->
    <div class="wrapper content">
      <h1 class="title">Sorry!</h1>
      <div class="content__text">
        <p>
          We jumped the gun on improving your Nike experience. It’s not ready just yet, but thanks for checking in. We'll be in touch soon with an update.
        </p>
      </div>
    </div>
    <!-- eslint-enable -->
  </div>
</template>

<script>
// @ is an alias to /src

// Components
import Header from '@/components/Header.vue';
import Banner from '@/components/Banner.vue';

export default {
  name: 'error',
  components: {
    Header,
    Banner,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  $content-width: 580px;

  .content {
    width: $content-width;
  }
</style>
